import { useAuth } from 'context/auth';
import useSWR, { SWRHook } from 'swr';

export const useSWRWhenAuthed: SWRHook = (key, ...args) => {
  const { isLoggedIn } = useAuth();
  const [fetcher, config] = args;
  return useSWR(isLoggedIn ? key : null, fetcher, config);
};
